module.exports = __webpack_public_path__ + "img/top-png-biaoti.c1feca3b.svg";